import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import { CheckAccess } from '../../../services/Functional'
import { SubscriptionPlansListWrapper } from './subscription-plans-list/SubscriptionPlansList'

const subscriptionPlansBreadcrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Enterprise Plans Requests',
    path: '/plans/enterprise-plan',
    isSeparator: false,
    isActive: false,
  },
]

export function EnterPrisePlan() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          index
          element={
            CheckAccess('enterprise_plan.index') ? (
              <>
                <PageTitle breadcrumbs={[subscriptionPlansBreadcrumbs[1]]}>
                  Enterprise Plan Listing
                </PageTitle>
                <SubscriptionPlansListWrapper />
              </>
            ) : (
              <Navigate to='/error' />
            )
          }
        />
      </Route>
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}